/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'confluence-analytics-byline.abbreviated-user-views.message':
    '{count, plural, =0 {Visualizações} one {1} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Visualizadores',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Análise} one {1 pessoa visualizou} other {{count} pessoas visualizaram}}',
};
